import { useQuery } from '@tanstack/react-query';
import { AvailableBrokerageOfferingSearchRequestQuery, AvailableBrokerageOfferingSearchResponse } from '@lio/api-types';
import { useClient } from '@utils/api-client';
import { config } from '@services/config';
import { searchProductOfferingsQueryParams } from '@services/productOffering/productOffering.helpers';

export const productOfferingKeys = {
  search: ['productOfferings'] as const,
  searchWithParams: (
    params: AvailableBrokerageOfferingSearchRequestQuery & {
      enabled?: boolean;
      brokerageId?: string;
    },
  ) => [...productOfferingKeys.search, params] as const,
};

export const useProductOfferings = (
  params: AvailableBrokerageOfferingSearchRequestQuery & {
    enabled?: boolean;
    brokerageId?: string;
  },
) => {
  const client = useClient();
  const queryParams = searchProductOfferingsQueryParams(params);
  const { brokerageId } = params;
  const result = useQuery<AvailableBrokerageOfferingSearchResponse, Error>({
    queryKey: [...productOfferingKeys.searchWithParams(params)],

    queryFn: async () => {
      const response = await client
        .get(`brokerage/${brokerageId}/available-offering?${queryParams}`)
        .json<AvailableBrokerageOfferingSearchResponse>();
      return response;
    },
    ...config,
    enabled: Boolean(brokerageId && brokerageId !== ''),
  });

  return { ...result, productOfferings: result.data };
};
